import gql from 'graphql-tag';

export const ConnectCustomContentModulesQuery = gql`
	query ConnectCustomContentModulesQuery @experimental {
		experimentalCustomContentConnectModules {
			modules
		}
	}
`;
